export default {
  autocomplete: null,
  transactions: [],
  subdistributors: [],
  stores: [],
  chains: [],
  grants: [],
  installs: [],
  params: {
    distributor_id: null,
    subdistributor_id: null,
    chain_id: null,
    store_id: null,
  },
  loading: false,
};
